import moment from 'moment';
import { DATE_SAVE_TO_DB } from '../../constants';

/* eslint-disable default-param-last */
const initialState = {
  selected_client_id: null,
  selected_client_name: null,
  selected_site_id: null,
  selected_site_name: null,
  selected_start_date: DATE_SAVE_TO_DB(
    moment(new Date(), 'DD/MM/YYYY').startOf('week').format('DD/MM/YYYY')
  ),
  selected_end_date: DATE_SAVE_TO_DB(
    moment(new Date(), 'DD/MM/YYYY').endOf('week').format('DD/MM/YYYY')
  )
};

const agency = (state = initialState, action) => {
  switch (action.type) {
    case 'SELECT_CLIENT':
      return {
        ...state,
        selected_client_id: action.payload.selected_client_id,
        selected_client_name: action.payload.selected_client_name,
        is_restricted: action.payload.is_restricted,
        weekday_start: action.payload.weekday_start,
        total_assignment_pay: action.payload.total_assignment_pay
      };
    case 'SELECT_SITE':
      return {
        ...state,
        selected_site_id: action.payload.selected_site_id,
        selected_site_name: action.payload.selected_site_name
      };
    case 'SELECT_DATE_RANGE':
      return {
        ...state,
        selected_start_date: action.payload.start_date,
        selected_end_date: action.payload.end_date
      };
    default:
      return state;
  }
};

export default agency;
